var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 0c5.51 0 10 4.49 10 10s-4.49 10-10 10S0 15.51 0 10 4.49 0 10 0zM6.676 5.633c-.292-.203-.696-.174-.956.087-.293.293-.293.767 0 1.06L8.939 10l-3.22 3.22-.086.103c-.203.293-.174.697.087.957.293.293.767.293 1.06 0L10 11.061l3.22 3.22.103.086c.293.203.697.174.957-.087.293-.293.293-.767 0-1.06L11.061 10l3.22-3.22.086-.104c.203-.292.174-.696-.087-.956-.293-.293-.767-.293-1.06 0L10 8.939l-3.22-3.22-.104-.086z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossFilled);
export default __webpack_public_path__ + "static/media/cross-filled.0042d7ff0ada0e69f2cc081207651957.svg";
export { ForwardRef as ReactComponent };